export default {
  // Common
  common: {
    welcome: 'Welcome',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search...',
    filter: 'Filter',
    export: 'Export',
    refresh: 'Refresh',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
  },

  // Auth
  auth: {
    login: 'Login',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password?',
    signIn: 'Sign In',
    loginSuccess: 'Logged in successfully',
    loginError: 'Invalid email or password',
    sessionExpired: 'Session expired. Please login again.',
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    instruments: 'Instruments',
    clients: 'Clients',
    accounts: 'Accounts',
    trading: 'Trading',
    reports: 'Reports',
    audit_log: 'Audit log',
    withdrawals: 'Withdrawals',
    deposits: 'Deposits',
    settings: 'Settings',
    plugins: 'Plugins',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    overview: 'Overview',
    stats: 'Statistics',
    totalClients: 'Total Clients',
    totalAccounts: 'Total Accounts',
    openPositions: 'Open Positions',
    todayPnL: "Today's P&L",
    liveAccounts: 'Live Accounts',
    demoAccounts: 'Demo Accounts',
    activeClients: 'Active Clients',
    newClients: 'New Clients',
    volumeChart: 'Trading Volume (7 Days)',
    pnlTrend: 'P&L Trend (30 Days)',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
  },

  // Instruments
  instruments: {
    title: 'Instrument Management',
    library: 'Instrument Library',
    enabled: 'Enabled Instruments',
    feed: 'Feed Instruments',
    symbol: 'Symbol',
    category: 'Category',
    priceScale: 'Price Scale',
    leverage: 'Leverage',
    spread: 'Spread',
    commission: 'Commission',
    enable: 'Enable',
    disable: 'Disable',
    bulkEnable: 'Bulk Enable',
    settings: 'Settings',
    tradeMode: 'Trade Mode',
    executionType: 'Execution Type',
    
    // Categories
    forex: 'Forex',
    crypto: 'Crypto',
    stocks: 'Stocks',
    indices: 'Indices',
    commodities: 'Commodities',
    
    // Settings tabs
    general: 'General',
    leverageLots: 'Leverage & Lots',
    spreads: 'Spreads',
    commissions: 'Commissions',
    riskManagement: 'Risk Management',
    advanced: 'Advanced',
    
    // Settings fields
    maxLeverage: 'Max Leverage',
    minLotSize: 'Min Lot Size',
    maxLotSize: 'Max Lot Size',
    lotStep: 'Lot Step',
    spreadType: 'Spread Type',
    spreadMarkup: 'Spread Markup',
    fixedSpread: 'Fixed Spread',
    commissionPerLot: 'Commission Per Lot',
    commissionType: 'Commission Type',
    stopLevel: 'Stop Level',
    freezeLevel: 'Freeze Level',
    maxPositions: 'Max Positions',
    
    // Messages
    enableSuccess: 'Instrument enabled successfully',
    disableSuccess: 'Instrument disabled successfully',
    updateSuccess: 'Settings updated successfully',
    bulkEnableSuccess: 'Instruments enabled successfully',
  },

  // Clients
  clients: {
    title: 'Clients',
    clientsList: 'Clients List',
    clientDetails: 'Client Details',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    country: 'Country',
    kycStatus: 'KYC Status',
    accountCount: 'Accounts',
    totalBalance: 'Total Balance',
    lastLogin: 'Last Login',
    createdAt: 'Created At',
    verified: 'Verified',
    pending: 'Pending',
    rejected: 'Rejected',
  },

  // Accounts
  accounts: {
    title: 'Accounts',
    accountsList: 'Accounts List',
    accountDetails: 'Account Details',
    accountNumber: 'Account Number',
    accountType: 'Account Type',
    balance: 'Balance',
    equity: 'Equity',
    margin: 'Margin',
    freeMargin: 'Free Margin',
    marginLevel: 'Margin Level',
    leverage: 'Leverage',
    credit: 'Credit',
    debit: 'Debit',
    adjustBalance: 'Adjust Balance',
    changeLeverage: 'Change Leverage',
    live: 'Live',
    demo: 'Demo',
  },

  // Trading
  trading: {
    title: 'Trading',
    positions: 'Positions',
    orders: 'Orders',
    history: 'History',
    symbol: 'Symbol',
    side: 'Side',
    volume: 'Volume',
    openPrice: 'Open Price',
    currentPrice: 'Current Price',
    pnl: 'P&L',
    buy: 'Buy',
    sell: 'Sell',
    open: 'Open',
    pending: 'Pending',
    closed: 'Closed',
    closedAt: 'Closed At',
    openedAt: 'Opened At',
    price: 'Price',
    totalTrades: 'Total Trades',
    winningTrades: 'Winning Trades',
    losingTrades: 'Losing Trades',
    totalPnL: 'Total P&L',
    account: 'Account',
    status: 'Status',
    swap: 'Swap',
    commission: 'Commission',
    ticket: 'Ticket',
    noPositions: 'No open positions found',
    noOrders: 'No pending orders found',
    noHistory: 'No trade history found',
  },

  // Reports
  reports: {
    title: 'Reports',
    exposure: 'Exposure Report',
    profitability: 'Client Profitability',
    daily: 'Daily Report',
    dateRange: 'Date Range',
    totalExposure: 'Total Exposure',
    netVolume: 'Net Volume',
    topWinners: 'Top Winners',
    topLosers: 'Top Losers',
    buyVolume: 'Buy Volume',
    sellVolume: 'Sell Volume',
    positionCount: 'Position Count',
    winRate: 'Win Rate',
    rank: 'Rank',
    client: 'Client',
    noData: 'No data available',
    totalVolume: 'Total Volume',
    commission: 'Commission',
    activeAccounts: 'Active Accounts',
    export: 'Export',
    download: 'Download',
    positions: 'Positions',
    trades: 'Trades',
    winning: 'Winning',
    losing: 'Losing',
  },

  // Settings
  settings: {
    title: 'Settings',
    brokerInfo: 'Broker Information',
    accountGroups: 'Account Groups',
    brokerName: 'Broker Name',
    domain: 'Domain',
    primaryColor: 'Primary Color',
    secondaryColor: 'Secondary Color',
    logo: 'Logo',
    supportEmail: 'Support Email',
    supportPhone: 'Support Phone',
    generalInfo: 'General Information',
    branding: 'Branding',
    addNewGroup: 'Add New Group',
    noGroupsFound: 'No account groups found',
    default: 'Default',
    maxLeverage: 'Max Leverage',
    marginCall: 'Margin Call',
    stopOut: 'Stop Out',
    commission: 'Commission',
    maxLotSize: 'Max Lot Size',
    execution: 'Execution',
    hedgingAllowed: 'Hedging Allowed',
    scalpingAllowed: 'Scalping Allowed',
    eaTrading: 'EA Trading',
    nbpEnabled: 'NBP Enabled',
    saving: 'Saving...',
    groupName: 'Group Name',
    description: 'Description',
    editGroup: 'Edit Group',
    deleteGroup: 'Delete Group',
  },

  // Theme
  theme: {
    light: 'Light Mode',
    dark: 'Dark Mode',
    toggle: 'Toggle Theme',
  },

  // Language
  language: {
    english: 'English',
    arabic: 'العربية',
    select: 'Select Language',
  },

  // Errors
  errors: {
    general: 'Something went wrong',
    networkError: 'Network error. Please check your connection.',
    unauthorized: 'Unauthorized. Please login again.',
    forbidden: 'Access denied.',
    notFound: 'Resource not found.',
    serverError: 'Server error. Please try again later.',
  },

  // Success messages
  success: {
    saved: 'Saved successfully',
    updated: 'Updated successfully',
    deleted: 'Deleted successfully',
    created: 'Created successfully',
  },
};
